<div class="chatbot-wrapper">
  <!-- Floating Chat Icon -->
  <div class="chatbot-icon" (click)="toggleChat()" *ngIf="!isOpen">
    <div class="chatbot-icon__inner">
      <img src="assets/chatbot/icon-outer.png" alt="Chatbot" class="chatbot-icon__gif" />
    </div>
  </div>

  <!-- Chat Window -->
  <div class="chatbot-window" *ngIf="isOpen" [ngStyle]="chatWindowStyle" [class.chatbot-window--dragging]="isDragging" [class.chatbot-window--sidebar-collapsed]="isSidebarCollapsed">
    <!-- Sidebar -->
    <div class="chatbot-sidebar" [class.chatbot-sidebar--collapsed]="isSidebarCollapsed" (mousedown)="onDragHandleMouseDown($event)">
      <div class="chatbot-sidebar__content" *ngIf="!isSidebarCollapsed">
        <!-- Sidebar Header -->
        <div class="chatbot-sidebar__header">
          <div class="chatbot-sidebar__avatar"><img src="assets/chatbot/icon-inner.png" alt="avatar" class="chatbot-sidebar__avatar-img"></div>
          <div class="chatbot-sidebar__title-area">
            <span class="chatbot-sidebar__name">博小达</span>
            <span class="chatbot-sidebar__version">经销商门户智能助手</span>
          </div>
          <button class="chatbot-sidebar__collapse-btn" (click)="toggleSidebar()">
            <img src="assets/chatbot-new-icons/left_panel_close.svg" alt="left_panel_close" />
          </button>
        </div>

        <!-- New Chat Button -->
        <button class="chatbot-sidebar__new-chat" (click)="startNewChat()">
          <img src="assets/chatbot-new-icons/add.svg" alt="add" />
          <span>开启新对话</span>
        </button>

        <div class="chatbot-sidebar__section-header">
          <span class="chatbot-sidebar__section-label">快捷服务</span>
        </div>
        <!-- Quick Service Button -->
        <button class="chatbot-sidebar__quick-service"
          [class.chatbot-sidebar__quick-service--disabled]="messages.length === 0"
          [disabled]="messages.length === 0"
          (click)="toggleQuickModules()">
          <span
            class="chatbot-sidebar__quick-service-icon chatbot-svg-mask-icon"
            style="--icon-url: url(assets/chatbot-new-icons/dashboard.svg); background-color: #005691"
            aria-label="dashboard">
          </span>
          <span>快捷服务</span>
        </button>

        <!-- Scrollable body -->
        <div class="chatbot-sidebar__scroll-body">
          <!-- History -->
          <div class="chatbot-sidebar__section">
            <div class="chatbot-sidebar__section-header">
              <span class="chatbot-sidebar__section-label">历史记录</span>
            </div>
            <div class="chatbot-sidebar__history">
              <ng-container *ngIf="isHistoryLoading">
                <div class="chatbot-sidebar__skeleton-item" *ngFor="let i of [1,2,3]">
                  <div class="chatbot-sidebar__skeleton-icon"></div>
                  <div class="chatbot-sidebar__skeleton-line"></div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isHistoryLoading">
                <ng-container *ngFor="let item of historyList">
                  <div class="chatbot-sidebar__history-item"
                    [class.chatbot-sidebar__history-item--active]="item.active"
                    (click)="loadHistoryChat(item)">
                    <img class="chatbot-sidebar__history-icon" src="assets/chatbot-new-icons/history.svg" alt="history" />
                    <span class="chatbot-sidebar__history-title">{{ item.title }}</span>
                    <button class="chatbot-sidebar__history-delete" (click)="deleteHistoryItem(item, $event)" title="删除">
                      <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                        <path d="M1 3.5H13M5 3.5V2H9V3.5M2.5 3.5L3 12H11L11.5 3.5H2.5ZM5.5 6V10M8.5 6V10" stroke="#bbb" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>

          <!-- Tags / Categories -->
          <div class="chatbot-sidebar__divider"></div>
          <div class="chatbot-sidebar__section">
            <span class="chatbot-sidebar__section-label">小标签</span>
            <div class="chatbot-sidebar__tags">
              <ng-container *ngIf="isHistoryLoading">
                <div class="chatbot-sidebar__skeleton-item" *ngFor="let i of [1,2,3]">
                  <div class="chatbot-sidebar__skeleton-dot"></div>
                  <div class="chatbot-sidebar__skeleton-line chatbot-sidebar__skeleton-line--short"></div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isHistoryLoading">
                <ng-container *ngFor="let group of categoryGroups">
                  <div class="chatbot-sidebar__tag-item chatbot-sidebar__tag-item--clickable"
                    (click)="group.items.length ? toggleCategoryCollapse(group) : null">
                    <img class="chatbot-sidebar__tag-icon" src="assets/chatbot-new-icons/label.svg" alt="label" />
                    <span>{{ group.category }}</span>
                    <span class="chatbot-sidebar__tag-count">{{ group.items.length }}</span>
                    <svg *ngIf="group.items.length" class="chatbot-sidebar__tag-chevron"
                      [class.chatbot-sidebar__tag-chevron--collapsed]="group.collapsed"
                      width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M2 4L5 7L8 4" stroke="#94a3b8" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <ng-container *ngIf="!group.collapsed">
                    <div class="chatbot-sidebar__tag-sub-list">
                      <div class="chatbot-sidebar__history-item chatbot-sidebar__history-item--sub"
                        *ngFor="let item of group.items"
                        [class.chatbot-sidebar__history-item--active]="item.active"
                        (click)="loadHistoryChat(item)">
                        <img class="chatbot-sidebar__history-icon" src="assets/chatbot-new-icons/history.svg" alt="history" />
                        <span class="chatbot-sidebar__history-title">{{ item.title }}</span>
                        <button class="chatbot-sidebar__history-delete" (click)="deleteHistoryItem(item, $event)" title="删除">
                          <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                            <path d="M1 3.5H13M5 3.5V2H9V3.5M2.5 3.5L3 12H11L11.5 3.5H2.5ZM5.5 6V10M8.5 6V10" stroke="#bbb" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Footer (always pinned) -->
        <div class="chatbot-sidebar__footer">
          <div class="chatbot-sidebar__divider"></div>
          <button class="chatbot-sidebar__footer-btn">
            <img src="assets/chatbot-new-icons/settings.svg" alt="settings" />
            <span>设置</span>
          </button>
          <button class="chatbot-sidebar__footer-btn">
            <img src="assets/chatbot-new-icons/help.svg" alt="help" />
            <span>帮助</span>
          </button>
        </div>
      </div>

      <!-- Collapsed Sidebar -->
      <div class="chatbot-sidebar__collapsed-content" *ngIf="isSidebarCollapsed">
        <button class="chatbot-sidebar__collapse-btn" (click)="toggleSidebar()">
          <img src="assets/chatbot-new-icons/right_panel_open.svg" alt="right_panel_open" />
        </button>
        <button class="chatbot-sidebar__collapsed-new-chat" (click)="startNewChat()">
          <img src="assets/chatbot-new-icons/add.svg" alt="add" />
        </button>
        <div class="chatbot-sidebar__collapsed-footer">
          <button class="chatbot-sidebar__collapsed-icon-btn">
            <img src="assets/chatbot-new-icons/settings.svg" alt="settings" />
          </button>
          <button class="chatbot-sidebar__collapsed-icon-btn">
            <img src="assets/chatbot-new-icons/help.svg" alt="help" />
          </button>
        </div>
      </div>
    </div>

    <!-- Main Area -->
    <div class="chatbot-main">
      <!-- Top Bar -->
      <div class="chatbot-topbar" [class.chatbot-topbar--transparent]="messages.length === 0" (mousedown)="onDragHandleMouseDown($event)">
        <span class="chatbot-topbar__title" *ngIf="messages.length > 0">{{ currentChatTitle }}</span>
        <button class="chatbot-topbar__close" (click)="closeChat()">
          <img src="assets/chatbot-new-icons/close.svg" alt="close" />
        </button>
      </div>

      <!-- Chat Content -->
      <div class="chatbot-content" #messagesContainer>
        <!-- Messages loading overlay -->
        <div class="chatbot-messages-loading" *ngIf="isMessagesLoading">
          <div class="chatbot-messages-loading__spinner"></div>
          <span class="chatbot-messages-loading__text">加载中...</span>
        </div>

        <!-- Welcome Section -->
        <div class="chatbot-welcome" *ngIf="messages.length === 0">
          <h3 class="chatbot-welcome__title">
            欢迎回来，<span class="chatbot-welcome__title-gradient">博小达</span> 为您服务
          </h3>
          <p class="chatbot-welcome__subtitle">今天有什么我可以帮您的？您可以点击以下常用功能或在对话框里提问。</p>

          <!-- Quick Modules Grid -->
          <div class="chatbot-modules">
            <div class="chatbot-module-card" *ngFor="let module of getDisplayedModules()" [style.--accent-color]="module.accentColor">
              <div class="chatbot-module-card__header">
                <span
                  class="chatbot-module-card__icon chatbot-svg-mask-icon"
                  [style.--icon-url]="'url(assets/chatbot-new-icons/' + module.icon + '.svg)'"
                  [style.background-color]="module.accentColor"
                  [attr.aria-label]="module.icon">
                </span>
                <span class="chatbot-module-card__title" [style.color]="module.accentColor">{{ module.title }}</span>
              </div>
              <p class="chatbot-module-card__description">{{ module.description }}</p>
              <div class="chatbot-module-card__items">
                <div class="chatbot-module-card__item" *ngFor="let item of module.items; let i = index"
                  (click)="onQuickItemClick(item)">
                  <span>{{ item }}</span>
                  <span
                    class="chatbot-module-card__item-icon chatbot-svg-mask-icon"
                    [style.--icon-url]="'url(assets/chatbot-new-icons/' + module.itemIcons[i] + '.svg)'"
                    [attr.aria-label]="module.itemIcons[i]">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Messages -->
        <div class="chatbot-messages" *ngIf="messages.length > 0">
          <div class="chatbot-message" *ngFor="let msg of messages"
            [ngClass]="{'chatbot-message--user': msg.role === 'user', 'chatbot-message--assistant': msg.role === 'assistant'}">
            <div class="chatbot-message__avatar" *ngIf="msg.role === 'assistant'">
              <img src="assets/chatbot/icon-inner.png" alt="assistant" class="chatbot-message__avatar-img">
            </div>
            <div class="chatbot-message__avatar chatbot-message__avatar--user" *ngIf="msg.role === 'user'">
              {{ getUserInitials() }}
            </div>
            <div class="chatbot-message__bubble" *ngIf="msg.role === 'user'">
              <img *ngIf="msg.imageUrl" [src]="msg.imageUrl" class="chatbot-message__bubble-image" />
              <span *ngIf="msg.content && !msg.imageUrl">{{ msg.content }}</span>
              <div *ngIf="msg.content && msg.imageUrl" class="chatbot-message__bubble-file-info">
                <img src="assets/chatbot-new-icons/description.svg" alt="description" style="width:14px;height:14px;flex-shrink:0" />
                <span>{{ msg.content }}</span>
              </div>
            </div>
            <div class="chatbot-message__bubble-wrapper" *ngIf="msg.role === 'assistant'">
              <img src="assets/chatbot/header-brand.png" class="chatbot-message__brand-header" />
              <div class="chatbot-message__bubble chatbot-message__bubble--markdown">
                <div class="thinking-indicator" *ngIf="msg.isStreaming && !msg.content">
                  <span class="thinking-label">思考中</span>
                  <span class="thinking-wave">
                    <span></span><span></span><span></span>
                  </span>
                </div>
                <div *ngIf="msg.content" [innerHTML]="msg.htmlContent || msg.content"></div>
                <span class="streaming-cursor" *ngIf="msg.isStreaming && msg.content">▌</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Quick Modules Panel (toggled by 快捷服务 button) -->
        <div class="chatbot-quick-panel" *ngIf="showQuickModules">
          <div class="chatbot-quick-panel__header">
            <span class="chatbot-quick-panel__title">快捷服务</span>
            <button class="chatbot-quick-panel__close" (click)="hideQuickModules()">
              <img src="assets/chatbot-new-icons/close.svg" alt="close" />
            </button>
          </div>
          <div class="chatbot-modules">
            <div class="chatbot-module-card" *ngFor="let module of getDisplayedModules()" [style.--accent-color]="module.accentColor">
              <div class="chatbot-module-card__header">
                <span
                  class="chatbot-module-card__icon chatbot-svg-mask-icon"
                  [style.--icon-url]="'url(assets/chatbot-new-icons/' + module.icon + '.svg)'"
                  [style.background-color]="module.accentColor"
                  [attr.aria-label]="module.icon">
                </span>
                <span class="chatbot-module-card__title" [style.color]="module.accentColor">{{ module.title }}</span>
              </div>
              <p class="chatbot-module-card__description">{{ module.description }}</p>
              <div class="chatbot-module-card__items">
                <div class="chatbot-module-card__item" *ngFor="let item of module.items; let i = index"
                  (click)="onQuickItemClick(item)">
                  <span>{{ item }}</span>
                  <span
                    class="chatbot-module-card__item-icon chatbot-svg-mask-icon"
                    [style.--icon-url]="'url(assets/chatbot-new-icons/' + module.itemIcons[i] + '.svg)'"
                    [attr.aria-label]="module.itemIcons[i]">
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="chatbot-footer" (mousedown)="onDragHandleMouseDown($event)">
        <div class="chatbot-footer__input-area">
          <!-- File Preview -->
          <div class="chatbot-footer__file-preview" *ngIf="selectedFile">
            <div class="chatbot-footer__file-preview-image" *ngIf="safeFilePreviewUrl">
              <img [src]="safeFilePreviewUrl" class="chatbot-footer__file-preview-thumb" />
              <span class="chatbot-footer__file-preview-name">{{ selectedFile.name }}</span>
              <button class="chatbot-footer__file-preview-remove" (click)="removeSelectedFile()">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M9 3L3 9M3 3L9 9" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </button>
            </div>
            <div class="chatbot-footer__file-preview-inner" *ngIf="!filePreviewUrl">
              <img src="assets/chatbot-new-icons/description.svg" alt="description" style="width:14px;height:14px" />
              <span class="chatbot-footer__file-preview-name">{{ selectedFile.name }}</span>
              <button class="chatbot-footer__file-preview-remove" (click)="removeSelectedFile()">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M9 3L3 9M3 3L9 9" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </button>
            </div>
          </div>
          <span
            class="chatbot-footer__input-icon chatbot-svg-mask-icon chatbot-footer__input-icon--gradient"
            style="--icon-url: url(assets/chatbot-new-icons/auto_awesome.svg)"
            aria-label="auto_awesome">
          </span>
          <input class="chatbot-footer__input" [(ngModel)]="inputMessage" (keydown)="onKeyDown($event)"
            placeholder="输入您的问题，如 '查询我的最新订单状态'..." />
          <div class="chatbot-footer__actions">
            <input type="file" accept="image/*,.xlsx,.xls,.csv,.pdf,.doc,.docx" #fileInput style="display: none"
              (change)="onFileSelected($event)" />
            <button class="chatbot-footer__action-btn" (click)="fileInput.click()">
              <img class="chatbot-icon--attach-file" src="assets/chatbot-new-icons/attach_file.svg" alt="attach_file" />
            </button>
            <button class="chatbot-footer__send-btn" (click)="sendMessage()"
              [disabled]="!inputMessage.trim() && !selectedFile">
              <img class="chatbot-icon--send" src="assets/chatbot-new-icons/send.svg" alt="send" />
            </button>
          </div>
        </div>
        <div class="chatbot-footer__tags" *ngIf="messages.length === 0">
          <span class="chatbot-footer__tags-label">快捷提问:</span>
          <span class="chatbot-footer__tag" *ngFor="let tag of quickTags" (click)="onTagClick(tag)">{{ tag }}</span>
        </div>
        <p class="chatbot-footer__disclaimer">博小达可能会犯错，信息仅供参考，请您依据实际需求检查确认。</p>
      </div>
    </div>
  </div>
</div>
